export default {
  default: () => import("/app/layouts/default.vue")
}